import { materialCells, materialRenderers } from "@jsonforms/material-renderers";
import { JsonForms } from "@jsonforms/react";
import type { JsonSchema, UISchemaElement } from "@jsonforms/core";

interface FormWrapperProps {
  schema: JsonSchema;
  uischema: UISchemaElement;
  data: Record<string, unknown>;
  onChange: (data: Record<string, unknown>) => void;
}

export function FormWrapper({
  schema,
  uischema,
  data,
  onChange,
}: FormWrapperProps) {
  return (
    <JsonForms
      schema={schema}
      uischema={uischema}
      data={data}
      renderers={materialRenderers}
      cells={materialCells}
      onChange={({ data: newData }) => onChange(newData ?? {})}
    />
  );
}
